import type { Transition } from 'motion-dom'

/**
 * Spring used for sliding animations in modals.
 */
export const modalSlideSpring: Transition = {
  type: 'spring',
  stiffness: 400,
  damping: 40,
}

/**
 * Spring used for popover slide animations.
 */
export const popoverSlideSpring: Transition = {
  type: 'spring',
  stiffness: 1200,
  damping: 70,
}

/**
 * Spring used for static transitions.
 */
export const staticTransition: Transition = {
  type: 'keyframes',
  duration: 0.5,
  ease: [0.32, 0.72, 0, 1],
}

/**
 * Spring used for carousel transitions.
 */
export const carouselSpring: Transition = {
  type: 'spring',
  stiffness: 350,
  damping: 40,
}

/**
 * Spring used for carousel bounce transitions.
 */
export const carouselBounceSpring: Transition = {
  type: 'spring',
  stiffness: 350,
  damping: 25,
}

/**
 * Spring used for animations where elements are shuffling around
 * or being resized.
 */
export const shuffleTransition: Transition = {
  type: 'spring',
  stiffness: 2400,
  damping: 200,
  bounce: 0,
}

/**
 * Crisp spring for small indicator movements, like tab underlines and
 * selection indicators.
 */
export const indicatorSpring: Transition = {
  type: 'spring',
  stiffness: 700,
  damping: 40,
}

/**
 * Spring used for wizard page content entrances.
 */
export const pageContentSpring: Transition = {
  type: 'spring',
  stiffness: 500,
  damping: 35,
}
